<template>
  <div class="d-flex align-center">
    <v-form ref="form" lazy-validation>
      <v-text-field
        :label="generateMessage('requests.actions.tech_intervened') + ' *'"
        :value="value | displayTechName"
        readonly
        outlined
        :disabled="disabled"
        :loading="!(value && value.first_name)"
        :rules="[(v) => !!v || 'Ce champ est obligatoire']"
        class="mx-2"
        color="success"
      />
    </v-form>
    <e-dispatch-technician-selection-dialog
      @affect="$emit('input', $event)"
      btn-color="success"
      :disabled="disabled"
      :entityId="entityId"
      :property-id="propertyId"
      :request="request"
    />
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';
import eDispatchTechnicianSelectionDialog from '@/pages/eDispatch/requestActions/eDispatchTechnicianSelectionDialog';

export default {
  name: 'eDispatchTechnicianSearchField',
  components: { eDispatchTechnicianSelectionDialog },
  props: {
    disabled: { type: Boolean, required: false },
    entityId: { type: String, required: false },
    propertyId: { type: Number, required: true },
    value: { type: Object, required: false },
    request: { type: Object, required: false },
  },
  filters: {
    displayTechName(tech) {
      return tech && tech.first_name && `${tech.first_name} ${tech.last_name}`;
    },
  },
  methods: {
    generateMessage,
    validate() {
      return this.$refs.form.validate();
    },
    resetValidation() {
      return this.$refs.form.resetValidation();
    },
  },
};
</script>
